<template>
  <div class="user-contact" :class="{ 'app-invalid-group': !isComponentValid }">
    <h4>Confirmation will be sent via email and / or text for the transaction(s) in the cart</h4>
    <fieldset>
      <legend>
        <div class="component-container">
          <ContactEmail :verify="verify" @doEmail="setEmail" @doResetVerify="resetVerify" :embedded="true" ref="ContactEmail"/>
          <p hidden ref="noContactInfo" class="app-invalid-msg msg-offset-1">
            Email is required.
          </p>
          <ContactPhone :verify="verify" @doPhone="setPhone" @doResetVerify="resetVerify" :embedded="true" ref="ContactPhone" />
          </div>
      </legend>
    </fieldset>


  </div>
</template>

<script>

import * as COMMONS from '../../store/_commons';
import { mapGetters, mapActions, mapState } from 'vuex'
import ContactPhone from '@/components/contact/ContactPhone'
import ContactEmail from '@/components/contact/ContactEmail'
import { phoneMixin } from '@/utils/phoneMixin';

export default {
  name: 'ContactInformation',
  components: {
    ContactPhone,
    ContactEmail,
  },
  props: {
    verify: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      stepNum: 4,
      screenData: {},
      enableNext: true,

      myPhone: '',
      myEmail: '',
      myNotification: true,  // for selected btn indicator
      sendYes: 'sendYes',         // for element id and value
      sendNo: 'sendNo',
      isComponentValid: true,     // this parent's validations
      isPhoneValidated: true,     // from ContactPhone
      isEmailValidated: true,     // from ContactEmail

      isModify: false,
    }
  },
  mixins: [
    phoneMixin,
  ],
  computed: {
    ...mapGetters({
        personalInfo: COMMONS.GUEST_PERSONAL_INFO,
    }),
    ...mapState([
      'LANG',
      'STEPS',
    ]),
    language() {
      return this.LANG;
    },
  },
  created() {
    this.myNotification = this.getIsConsentProvided();
  },
  mounted() {
      console.log( this.personalInfo.personalInformation.phone )
      this.$refs.ContactEmail.myEmail = this.personalInfo.personalInformation && this.personalInfo.personalInformation.email || '';
      this.$refs.ContactEmail.myPhone = this.personalInfo.personalInformation && this.personalInfo.personalInformation.phone || '';

      let myPhone = this.personalInfo.personalInformation && this.personalInfo.personalInformation.phone;
      const phoneNum = this.formatPhoneForWebapp(myPhone);
      console.log( phoneNum )
      if (phoneNum && phoneNum.length === 10) {
        this.myPhone = phoneNum;
        this.$refs.ContactPhone.split(phoneNum);
      }
    },

  watch: {
    async verify() {
      if (this.verify) {
        this.$refs.ContactPhone.checkPhone();
      }
    }
  },
  methods: {
    ...mapActions([
    ]),
    async continueToNextStep() {

      if(this.$refs.ContactPhone.myPhone.length > 0) {
        await this.$refs.ContactPhone.checkPhone();

        this.isPhoneValidated = this.$refs.ContactPhone.invalidPhone;
        // console.log('CONTPHONEVALIDATE', this.isPhoneValidated);
        if(this.isPhoneValidated) {
          return; 
        }
      }

      // show error message(s)
      this.toggleRequirementError();
      const hasContact = await this.hasContactInfo();
      this.isComponentValid = (hasContact && !this.isPhoneValidated);
      if (this.isComponentValid) { // this parent validations
        // all good - pass user info back to parent
        // this.isConsentProvided = (this.myNotification === this.sendYes);
        this.$emit('doContactValidated', {
          phone: this.myPhone,
          email: this.myEmail,
          isConsentProvided: this.myNotification,
          isModifyRequest: this.isModify,
        });
      } else {
        // missing contact info and/or consent (highlight the whole box)
        this.resetVerify();
      }
    },
    getIsConsentProvided() {
      if (this.$store.state.guestLogin.finalizationCart) {
        const userContact = this.this.$store.state.guestLogin.finalizationCart;
        if (userContact && userContact.isConsentProvided !==  undefined) {
          return (userContact.isConsentProvided);
        }
      }

      return undefined;
    },
    handleHidden(data) {
      const attr = 'hidden';
      const errorElem = this.$refs[data.ref];
      const hasError = data.error;
      if (errorElem) {
        if (hasError) {
          // display error message
          errorElem.removeAttribute(attr);
        } else {
          // add 'hidden' to <p> if it doesn't exist
          if (!errorElem.hasAttribute(attr)) {
            errorElem.setAttribute(attr, attr);
          }
        }
      }
    },
    hasContactInfo() {
      return (this.myEmail.length > 0);
    },
    resetVerify() {
      // reset children validations
      this.isPhoneValidated = false;
      this.isEmailValidated = false;

      // ask parent to reset its flag
      this.$emit('doResetVerify');
    },
    /**
     * Work differently from ModalContact's setEmail due to differences in props behavior.
     * @param data
     */
    setEmail(data) {
      this.myEmail = data.email;
      this.isEmailValidated = data.isValid;
      this.isPhoneValidated = this.$refs.ContactPhone.invalidPhone;

    },
    /**
     * Work differently from ModalContact's setPhone due to differences in props behavior.
     * @param data
     */
    async setPhone(data) {
      this.myPhone = data.phone;
      this.isPhoneValidated = data.isValid;
      this.isPhoneValidated = await this.$refs.ContactPhone.invalidPhone;
      console.log( this.$refs.ContactPhone.myPhone );
    
      // move on if email has also been validated
      // console.log('ISPHONEVALIDATED', this.isPhoneValidated);
      // console.log('VERIFY', this.verify);
      if (this.verify && this.isPhoneValidated && this.isEmailValidated) {
        this.continueToNextStep();
      }
    },
    setNotifyMe(e) {
      this.myNotification = e.target.value;
    },
    /**
     * Toggle the error messages for Phone/Email and Notification Yes/No
     */
    toggleRequirementError() {
      // show error message(s), if needed
      this.$refs.ContactPhone.checkPhone();
      this.$refs.ContactEmail.checkEmail();
      this.isPhoneValidated = this.$refs.ContactPhone.invalidPhone;
      let phoneCharsValidate = this.$refs.ContactPhone.invalidPhoneNumChars;
        if(phoneCharsValidate){
          this.isPhoneValidated = phoneCharsValidate
        }
        else {
          this.handleHidden({ ref: 'noContactInfo', error: !this.hasContactInfo() });
        }
      // this.handleHidden({ ref: 'noConsentInfo', error: !this.myNotification });
    },
  }
}
</script>

<style lang="scss" scoped>
.user-contact {
  border: 1px solid var(--ri-gray);
  margin: 0.5em 0 1.5em;
  margin-top: 0rem;
  padding: calc(var(--padding-horizontal) * 0.125) calc(var(--padding-horizontal) * 0.35);

  h4{
    margin-top: 0.5rem;
  }
  
  @media only screen and (min-width: 330px) and (max-width: 405px) {
      padding: 1.1rem;
    }
    
  .component-container {
    display: block;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: flex-start;
    .conjunction {
      // do not use flex alignment due to conditional error <p>
      line-height: 2em;
      padding: 0 0.75em;
      margin-top: 0;
      @media (min-width: 355px) {
        margin-top: 2.5em;
      }
    }
  }
  &.app-invalid-group {     // does not override main's app-invalid-group but as a scrollIntoView indicator
    border: 1px solid var(--ri-red);
    box-shadow: 0 0 2px 2px var(--ri-red);
  }
  input[type="radio"] {
    margin: 0.5em 0;
  }
  .msg-offset {
    &-1 {
      margin-top: -1.25em;
      margin-bottom: 1em;
    }
    &-2 {
      margin-top: -1em;
      margin-bottom: 0.5em;
    }
  }
}
</style>
